export const regexCustomerID = RegExp(/^[0-9]{5,15}$/);
export const regexTaxNumber = RegExp(
  /^(?!.{16,})(?=.{10,})\d{1,14}-?\d{1,14}$/
);
export const regexNumberOnly = /^[0-9\b]+$/;
export const regexNumberAndHyphenOnly = /^[0-9-\b]+$/;
